import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import FilterListIcon from '@material-ui/icons/FilterList';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Popper } from '@material-ui/core';
import ScoutingBlockNameDropdown from '../dropdowns/BlockNameDropdown';
import { CROP } from '../../../appConstants';

interface IScoutingAssignmentBlockNameFilterProps {
    id ?: string;

    value ?: string;
    landName ?: string;

    onChange : (value : Array<string>) => void;

    cropType ?: CROP;
}

interface IScoutingAssignmentBlockNameFilterState {
    open : boolean;
}

export default class ScoutingAssignmentBlockNameFilter extends React.PureComponent<IScoutingAssignmentBlockNameFilterProps, IScoutingAssignmentBlockNameFilterState> {
    private readonly anchorEl : React.RefObject<HTMLButtonElement>;

    constructor(props : IScoutingAssignmentBlockNameFilterProps) {
        super(props);
        this.state = {
            open: false,
        };

        this.anchorEl = React.createRef<HTMLButtonElement>();
    }

    private readonly onClick = () => {
        this.setState({ open: !this.state.open });
    }

    private readonly onClose = (event : React.MouseEvent<Document, MouseEvent>) => {
        if (this.anchorEl.current?.contains(event.target as any)) {
            return;
        }

        event.preventDefault();

        this.setState({ open: false });
    }

    public readonly render = () => {
        const { id, value, cropType, onChange, landName } = this.props;
        const { open } = this.state;
        return (
            <span>
                <IconButton
                    aria-owns={`filter-menu-${id}`}
                    aria-haspopup='true'
                    onClick={this.onClick}
                    ref={this.anchorEl}
                    style={{
                        color: !value ? '' : '#FEE733',
                    }}
                    color='inherit'>
                    <FilterListIcon fontSize='small' />
                </IconButton>
                <Popper anchorEl={this.anchorEl.current} open={open} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom', marginTop: 8 }}
                        >
                            <Paper id={`filter-menu-${id}`}>
                                <ClickAwayListener onClickAway={this.onClose}>
                                    <div className='fdc ais jcfs'>
                                        <div className='fdc aic jcfs pl20 pr20 pb5 pt5 w240'>
                                        <ScoutingBlockNameDropdown
                                            value={!value ? [] : [value]}
                                            crop={cropType}
                                            fullWidth
                                            single
                                            onChange={onChange}
                                            landName={landName}                                        />
                                        </div>
                                    </div>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </span>
        );
    }
}
